import { connect } from "react-redux";
import { useDispatch, useSelector } from "react-redux";
import { Table, Button, Modal, Badge, Form, Spinner } from "react-bootstrap";
import React, { useState, useEffect, useMemo } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { getAllDoctors } from "../../actions/doctorActions";
import { getAllPatientProfiles } from "../../actions/patientProfileActions";
import { listAllInvoices } from "../../actions/invoiceActions";
import { listBlogs } from "../../actions/blogActions";
import { getFamilyMembers } from "../../actions/familyMembersActions";
import { CButton, CModal, CModalHeader, CModalBody } from "@coreui/react";
import MessageModal from "../Pages/MessageModel";
import { fetchBlogMetrics } from "src/actions/blogMetricsActions";
import { imgUrl } from "src/actions/types";
import {
  createOffer,
  getOffer,
  updateOffer,
  deleteOffer,
} from "../../actions/AllOffersActions";
import { Link } from 'react-router-dom'; 
const createOfferCss = `
.special-offer-modal-mainform {
  display: flex;
  flex-direction: row; /* Desktop: Two columns */
  height: 620px; /* Set a fixed height for the entire form on desktop */
  max-height: 80vh; /* Or a max-height relative to viewport height */
  overflow-y: hidden; /* Prevent the entire form from scrolling on desktop */
  overflow-x: hidden;
  background: #fff;
  border-radius: 18px;
  width:auto; /* Fixed width for desktop */
  margin: 0 auto;
  box-shadow: 0 3px 16px #16233808;
  border: 1.5px solid #eee;
  padding: 2px;
  gap: 2.5rem; /* Gap between the two columns */
  position: relative;
}

.offer-form-pane {
  flex: 1; /* Left pane takes available space */
  display: flex;
  flex-direction: column;
  border-right: 1.3px solid #ededed; /* Separator for desktop */
  padding-right: 2rem;
  overflow-y: auto; /* Scrollbar only for the left pane if content overflows */
  min-width: 0; /* Important for flex items to prevent overflow */
}

.offer-list-pane {
  flex: 1; /* Right pane takes available space */
  display: flex;
  flex-direction: column;
  padding-left: 1rem; /* Spacing from the separator */
  padding-top: 8px;
  padding-bottom: 8px;
  min-width: 0; /* Important for flex items to prevent overflow */
  /* No overflow-y: auto here, as chooser-list-outer handles its own scrolling */
}

.offer-img-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  width: 100%;
  flex-shrink: 0; /* Prevent image area from shrinking */
}

.display-img-area {
  width: 380px;
  height: 190px;
  background: #f4f4f4;
  border: 1.2px solid #ebebeb;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 4px;
  margin-top: -16px;
  flex-shrink: 0; /* Prevent image area from shrinking */
}

.offer-image {
  border-radius: 20px;
}

.display-img-area img {
  width: 100%;
  height: 100%;
  border-radius: 0px;
  object-fit: cover;
}

.label {
  color: #222;
  font-weight: 600;
  margin-bottom: 5px;
  font-size: 1.06rem;
}

input[type="text"],
input[type="date"],
input[type="number"],
textarea,
.form-select {
  border: 1.3px solid #e8e8e8 !important;
  border-radius: 7px !important;
  font-size: 1.06rem;
  background: #fcfcfc !important;
  color: #2c2c2c !important;
}

.section-row {
  display: flex;
  gap: 13px;
  margin-bottom: 10px;
  width: 100%;
}

.section-row > * {
  flex: 1;
}

.chooser-header {
  display: flex;
  align-items: center;
  gap: 13px;
  margin-bottom: 5px;
  min-height: 35px;
  flex-shrink: 0; /* Prevent header from shrinking */
}

.chooser-header input[type="checkbox"] {
  width: 18px;
  height: 18px;
}

.chooser-header .chooser-label {
  font-weight: 600;
  font-size: 1.1rem;
}

.chooser-header .chooser-search {
  max-width: 160px;
}

.chooser-list-outer {
  border: 1.3px solid #efefef;
  border-radius: 11px;
  background: #fff;
  flex: 1; /* Takes available space within the right pane */
  overflow-y: auto; /* This makes the assignee list scrollable */
  padding: 6px;
  margin: 10px 0 10px 0;
}

.chooser-table-container {
  max-height: 300px; /* Max height to enable vertical scrolling for the table itself */
  overflow-y: auto; /* Enable vertical scrolling for the table */
  border: 1px solid #ddd;
  border-radius: 4px;
}

.chooser-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 1.04rem;
}

.chooser-table th,
.chooser-table td {
  padding: 8px 12px;
  border-bottom: 1px solid #eee;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.chooser-table thead th {
  background-color: #f8f8f8;
  position: sticky;
  top: 0;
  z-index: 1;
  border-bottom: 1px solid #ddd;
}

.chooser-checkbox-cell {
  width: 40px;
  text-align: center;
}

.no-list-data {
  text-align: center;
  padding: 20px;
  color: #888;
}

.chooser-table input[type="checkbox"] {
  margin: 0;
  vertical-align: middle;
}

.button-bar-bottom {
  width: 99%; /* Adjusted to be almost full width of its container */
  display: flex;
  gap: 22px;
  margin-top: 13px;
  justify-content: left;
  flex-shrink: 0; /* Prevent buttons from shrinking */
}

.special-btn {
  background: #74b1cf;
  color: #fff;
  border: none;
  border-radius: 7px;
  font-weight: 700;
  font-size: 1rem;
  padding: 9px 42px;
  box-shadow: 0 2px 8px #2796ff07;
  letter-spacing: 0.04em;
}

/* Responsive styles */
@media (max-width: 1000px) {
  .special-offer-modal-mainform {
    flex-direction: column !important; /* Stack columns on tablet/mobile */
    height: 100vh !important; /* Full height on smaller screens */
    width: auto !important; /* Adjust width for tablet */
    max-width: 52vw; /* Keep max-width for tablet */
    max-height: 100vh !important;
    padding: 2px !important;
    gap: 0.8rem !important;
    overflow-y: auto !important; /* Allow modal to scroll on smaller screens */
    overflow-x: hidden !important;
    border-radius: 0 !important;
  }
  @media (max-width: 480px) {
    .special-offer-modal-mainform {
      margin: 0 !important;
      width: 90vw !important; /* Adjust width for mobile */
      max-width: 100vw; /* Allow full width on mobile */
    }
  }

  .offer-form-pane,
  .offer-list-pane {
    border-right: none !important; /* Remove separator on mobile/tablet */
    padding: 0 !important;
    margin-bottom: 14px !important;
    width: 100% !important;
    min-width: 0 !important;
    flex: initial !important; /* Allow panes to size based on content */
    overflow: visible !important; /* No internal scroll on panes on mobile */
  }

  .display-img-area {
    width: 100% !important;
    height: 140px !important;
    margin-top: 0 !important;
    margin-bottom: 10px !important;
  }

  .button-bar-bottom {
    flex-direction: row !important; /* Keep buttons in a row for mobile/tablet */
    gap: 14px !important;
    width: 100%;
    margin-top: 14px !important;
    justify-content: space-between !important;
  }
  .button-bar-bottom button {
    flex: 1 1 48%; /* Make buttons take up available space */
    width: 48%;
  }

  .chooser-table-container {
    max-height: 200px !important; /* Adjust max height for table on mobile */
    overflow-y: auto !important;
  }

  input[type="text"],
  input[type="date"],
  input[type="number"],
  textarea,
  .form-select {
    font-size: 1rem !important;
    width: 100% !important;
  }
}
/* WebKit (Chrome, Safari, Opera) scrollbar styles */
.offer-form-pane::-webkit-scrollbar,
.chooser-list-outer::-webkit-scrollbar,
.chooser-table-container::-webkit-scrollbar,
.special-offer-modal-mainform::-webkit-scrollbar {
  display: none; /* Hide scrollbar for WebKit browsers */
  width: 0; /* Also hide width in case display: none isn't enough */
  height: 0; /* Also hide height for horizontal scrollbars */
}

/* Firefox scrollbar styles */
.offer-form-pane,
.chooser-list-outer,
.chooser-table-container,
.special-offer-modal-mainform {
  scrollbar-width: none; /* Hide scrollbar for Firefox */
  -ms-overflow-style: none; /* Hide scrollbar for IE and Edge */
}
Use Arrow Up and Arrow Down to select a turn, Enter to jump to it, and Escape to return to the chat.


`;
const typesMenuOptions = [
  { value: "", label: "None" },
  { value: "global", label: "Global" },
  { value: "local", label: "Local" },
];
const AssignedTypeOptions = [
  { value: "all", label: "All" },
  { value: "doctor", label: "Doctor" },
  { value: "patient", label: "Patient" },
];
const rewardForPatientOptions = [
  { value: "", label: "None" },
  { value: "onCountAppointments", label: "On count of appointments" },
  { value: "onFamilyCount", label: "On family count" },
  { value: "onRevenueAppointments", label: "On revenue of appointments" },
];
const rewardForDoctorOptions = [
  { value: "", label: "None" },
  { value: "numAppointments", label: "No. of Appointments" },
  { value: "revenueAppointments", label: "Revenue of Appointments" },
  { value: "highestViewsArticles", label: " Highest Views on Articles" },
  { value: "averageViewsArticles", label: " Average Views on Articles" },
];
const rewardTypeOptions = [
  { value: "", label: "None" },
  { value: "%", label: "%" },
  { value: "money", label: "Money" },
  { value: "validity", label: "Validity" },
];
const assignToOptions = [
  { value: "all", label: "All" },
  { value: "doctor", label: "Doctor" },
  { value: "patient", label: "Patient" },
];
const publishStatusOptions = [
  { value: "Unpublish", label: "Unpublish" },
  { value: "Publish", label: "Publish" },
];

const CreateOffersForm = ({
  doctors,
  profiles,
  invoices,
  blogs,
  onCloseModal,
  onOfferAdded,
  onShowMessageModal,
  familyMembers,
  metrics,
  initialData = null, // new prop
  onUpdateOffer, // callback for update operation
}) => {
  const getTodayDateString = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const dispatch = useDispatch();
  const [mainList, setMainList] = useState([]);
  const [doctorList, setDoctorList] = useState([]);
  const [patientList, setPatientList] = useState([]);
  const [form, setForm] = useState({
    startDate: initialData?.startDate || getTodayDateString(),
    endDate: initialData?.endDate || getTodayDateString(),
    title: initialData?.title || "",
    description: initialData?.description || "",
    typesMenu: initialData?.type || "",
    assignedType: initialData?.assignedType || "",
    rewardForPatient: initialData?.rewardForPatient || "",
    rewardForDoctor: initialData?.rewardForDoctor || "",
    countStart: initialData?.rewardCountGreaterThan || "",
    countEnd: initialData?.rewardCountLessThan || "",
    rewardType: initialData?.rewardType || "",
    assignTo: initialData?.assignTo || "",
    publishStatus: initialData?.status || "",
    rewardapply: initialData?.rewardapply || "",
  });
  const [selectedIds, setSelectedIds] = useState(initialData?.assignedID || []);
  const [preview, setPreview] = useState(
    initialData?.image
      ? `${imgUrl}${initialData.image}`
      : "/assets/img/offers/default_offer_image.jpg"
  );
  const [imageFile, setImageFile] = useState(null);
  const [search, setSearch] = useState("");
  const [selectAll, setSelectAll] = useState(false);

  // Track if we have an existing image from initial data
  const [hasExistingImage, setHasExistingImage] = useState(
    !!initialData?.image
  );

  const patientStats = useMemo(() => {
    const data = {};
    (invoices || []).forEach((inv) => {
      if (inv.Status !== "Paid") return;
      const id = inv.PatientID;
      const amount = parseFloat(inv.paidAmount ?? inv.TotalAmount) || 0;
      if (!data[id]) data[id] = { count: 0, revenue: 0 };
      data[id].count += 1;
      data[id].revenue += amount;
    });
    return data;
  }, [invoices]);

  const doctorStats = useMemo(() => {
    const data = {};
    (invoices || []).forEach((inv) => {
      if (inv.Status !== "Paid") return;
      const id = inv.hospitalID; // use hospitalID as key for doctor stats
      const amount = parseFloat(inv.paidAmount ?? inv.TotalAmount) || 0;
      if (!data[id]) data[id] = { count: 0, revenue: 0 };
      data[id].count += 1;
      data[id].revenue += amount;
    });
    return data;
  }, [invoices]);

  const blogsWithViews = useMemo(() => {
    if (!blogs || !metrics) return [];

    return blogs.map((blog) => {
      const blogMetric = metrics[blog.id];
      return {
        ...blog,
        views: blogMetric ? parseInt(blogMetric.totalViews, 10) : 0, // <-- Corrected to totalViews
      };
    });
  }, [blogs, metrics]);
  const familyMemberCountByPatient = useMemo(() => {
    const counts = {};
    (familyMembers || []).forEach((member) => {
      const pid = member.PatientID;
      if (pid) {
        counts[pid] = (counts[pid] || 0) + 1;
      }
    });
    return counts;
  }, [familyMembers]);

  const doctorArticleStats = useMemo(() => {
    const data = {};

    (blogsWithViews || []).forEach((post) => {
      const authorId = post.hospitalID;
      if (authorId) {
        if (!data[authorId]) {
          data[authorId] = {
            numArticles: 0,
            totalViews: 0,
            individualBlogViews: [],
            highestViews: 0,
            averageViews: 0,
          };
        }
        const currentViews = post.views || 0;
        data[authorId].numArticles += 1;
        data[authorId].totalViews += currentViews;
        data[authorId].individualBlogViews.push(currentViews);
      }
    });

    Object.keys(data).forEach((authorId) => {
      const doctorData = data[authorId];
      if (doctorData.individualBlogViews.length > 0) {
        doctorData.highestViews = Math.max(...doctorData.individualBlogViews);
        doctorData.averageViews = (
          doctorData.totalViews / doctorData.numArticles
        ).toFixed(2);
      }
    });

    return data;
  }, [blogsWithViews]);
  const rewardColumnHeader = useMemo(() => {
    if (form.assignedType === "patient") {
      switch (form.rewardForPatient) {
        case "onCountAppointments":
          return "Appointments Count";
        case "onFamilyCount":
          return "Family Member Count";
        case "onRevenueAppointments":
          return "Revenue";
        default:
          return "Patient Reward";
      }
    } else if (form.assignedType === "doctor") {
      switch (form.rewardForDoctor) {
        case "numAppointments":
          return "Appointments Count";
        case "revenueAppointments":
          return "Revenue";
        case "numArticles":
          return "Articles Count";
        case "highestViewsArticles":
          return "Highest Views on Articles";
        case "averageViewsArticles":
          return "Average Views on Articles";
        default:
          return "Doctor Reward";
      }
    }
    return "Reward Details"; // Default header when nothing specific is selected
  }, [form.assignedType, form.rewardForPatient, form.rewardForDoctor]);
  useEffect(() => {
    if (doctors) setDoctorList(doctors);
    if (profiles) setPatientList(profiles);
  }, [doctors, profiles, blogs]);
  useEffect(() => {
    if (form.typesMenu === "global") {
      // For global offers, don't assign explicit lists or IDs
      if (
        form.assignedType === "all" ||
        form.assignedType === "doctor" ||
        form.assignedType === "patient"
      ) {
        // Reset mainList and selectedIds because no manual selection for global
        setMainList([]);
        setSelectedIds([]);
        setSelectAll(false);
      }
    } else if (form.typesMenu === "local") {
      // Your existing local filtering logic for doctor and patients here

      if (form.assignedType === "all") {
        const combinedList = [
          ...doctorList.map((doc) => ({ ...doc, _type: "Doctor" })),
          ...patientList.map((pat) => ({
            ...pat,
            _type: "Patient",
            PatientID: pat.PatientID || pat.id,
          })),
        ];
        setMainList(combinedList);
      } else if (form.assignedType === "doctor") {
        let filteredDoctors = doctorList;

        if (form.rewardForDoctor === "numAppointments") {
          filteredDoctors = doctorList.filter((doc) => {
            const id = doc.hospitalID;
            const count = doctorStats[id]?.count || 0;
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return count >= start && count <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return count >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return count <= end;
            }
            return true;
          });
        } else if (form.rewardForDoctor === "revenueAppointments") {
          filteredDoctors = doctorList.filter((doc) => {
            const id = doc.hospitalID;
            const revenue = doctorStats[id]?.revenue || 0;
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return revenue >= start && revenue <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return revenue >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return revenue <= end;
            }
            return true;
          });
        } else if (
          form.rewardForDoctor === "numArticles" ||
          form.rewardForDoctor === "highestViewsArticles" ||
          form.rewardForDoctor === "averageViewsArticles"
        ) {
          filteredDoctors = doctorList.filter((doc) => {
            const id = doc.hospitalID;
            const stats = doctorArticleStats[id]; // Get pre-calculated stats
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            let value = 0;

            if (form.rewardForDoctor === "numArticles") {
              value = stats?.numArticles || 0;
            } else if (form.rewardForDoctor === "highestViewsArticles") {
              value = stats?.highestViews || 0; // Access the new highestViews property
            } else if (form.rewardForDoctor === "averageViewsArticles") {
              value = parseFloat(stats?.averageViews) || 0; // Parse float for comparison
            }

            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return value >= start && value <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return value >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return value <= end;
            }
            return true;
          });
        }

        setMainList(
          filteredDoctors.map((doc) => ({ ...doc, _type: "Doctor" }))
        );
      } else if (form.assignedType === "patient") {
        let filteredPatients = patientList;

        if (form.rewardForPatient === "onCountAppointments") {
          filteredPatients = patientList.filter((p) => {
            const patientIdToLookup = p.PatientID || p.id;
            const count = patientStats[patientIdToLookup]?.count || 0;
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return count >= start && count <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return count >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return count <= end;
            }
            return true;
          });
        } else if (form.rewardForPatient === "onRevenueAppointments") {
          filteredPatients = patientList.filter((p) => {
            const patientIdToLookup = p.PatientID || p.id;
            const revenue = patientStats[patientIdToLookup]?.revenue || 0;
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return revenue >= start && revenue <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return revenue >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return revenue <= end;
            }
            return true;
          });
        } else if (form.rewardForPatient === "onFamilyCount") {
          filteredPatients = patientList.filter((p) => {
            const patientIdToLookup = p.PatientID || p.id;
            const familyCount =
              familyMemberCountByPatient[patientIdToLookup] || 0;
            const start = Number(form.countStart);
            const end = Number(form.countEnd);
            if (
              !isNaN(start) &&
              form.countStart !== "" &&
              !isNaN(end) &&
              form.countEnd !== ""
            ) {
              return familyCount >= start && familyCount <= end;
            } else if (!isNaN(start) && form.countStart !== "") {
              return familyCount >= start;
            } else if (!isNaN(end) && form.countEnd !== "") {
              return familyCount <= end;
            }
            return true;
          });
        }
        setMainList(
          filteredPatients.map((pat) => ({
            ...pat,
            _type: "Patient",
            PatientID: pat.PatientID || pat.id,
          }))
        );
      } else {
        setMainList([]);
      }
    } else {
      setMainList([]);
      setSelectedIds([]);
      setSelectAll(false);
    }

    setSelectedIds([]);
    setSelectAll(false);
  }, [
    form.typesMenu,
    form.assignedType,
    form.rewardForPatient,
    form.rewardForDoctor,
    form.countStart,
    form.countEnd,
    doctorList,
    patientList,
    patientStats,
    doctorStats,
    doctorArticleStats,
    familyMemberCountByPatient,
  ]);

  const displayedList = useMemo(() => {
    if (!search) return mainList;
    return mainList.filter((item) =>
      (item.firstName + " " + (item.lastName || ""))
        .toLowerCase()
        .includes(search.trim().toLowerCase())
    );
  }, [mainList, search]);
  useEffect(() => {
    if (initialData) {
      setForm({
        startDate: initialData.startDate || getTodayDateString(),
        endDate: initialData.endDate || getTodayDateString(),
        title: initialData.title || "",
        description: initialData.description || "",
        typesMenu: initialData.type || "",
        assignedType: initialData.assignedType || "",
        rewardForPatient: initialData.rewardForPatient || "",
        rewardForDoctor: initialData.rewardForDoctor || "",
        countStart: initialData.rewardCountGreaterThan || "",
        countEnd: initialData.rewardCountLessThan || "",
        rewardType: initialData.rewardType || "",
        assignTo: initialData.assignTo || "",
        publishStatus: initialData.status || "",
        rewardApply: initialData.rewardApply || "",
      });
      setSelectedIds(initialData.assignedID || []);
      setPreview(
        initialData.image
          ? `${imgUrl}${initialData.image}`
          : "/assets/img/offers/default_offer_image.jpg"
      );
      setImageFile(null);
      setHasExistingImage(!!initialData.image);
    }
  }, [initialData]);
  useEffect(() => {
    setSelectAll(
      displayedList.length > 0 &&
        displayedList.every((item) =>
          selectedIds.includes(item.PatientID || item.hospitalID || item.id)
        )
    );
  }, [displayedList, selectedIds]);

  let filteredRewardTypeOptions;

  if (form.assignedType === "patient") {
    // If assigned type is 'patient', show only '%' and 'Money'
    filteredRewardTypeOptions = rewardTypeOptions.filter(
      (opt) => opt.value === "" || opt.value === "%" || opt.value === "money"
    );
  } else {
    // For 'doctor' or any other type, show all options
    filteredRewardTypeOptions = rewardTypeOptions;
  }

  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedIds(
        selectedIds.filter(
          (id) =>
            !displayedList.some(
              (item) => (item.PatientID || item.hospitalID || item.id) === id
            )
        )
      );
    } else {
      const newIds = displayedList
        .map((item) => item.PatientID || item.hospitalID || item.id)
        .filter((id) => !selectedIds.includes(id));
      setSelectedIds([...selectedIds, ...newIds]);
    }
    setSelectAll(!selectAll);
  };

  const toggleSelect = (id) => {
    setSelectedIds(
      selectedIds.includes(id)
        ? selectedIds.filter((sid) => sid !== id)
        : [...selectedIds, id]
    );
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setPreview(URL.createObjectURL(file));
      setHasExistingImage(false); // User uploaded new image, don't rely on existing
    } else {
      setImageFile(null);
      // Only reset to default if there was no existing image
      if (!hasExistingImage) {
        setPreview("/assets/img/offers/default_offer_image.jpg");
      }
    }
  };

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));
  };

  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   const payload = {
  //     id: initialData?.id,
  //     hospitalID: "logindata.hospitalID",
  //     startDate: form.startDate,
  //     endDate: form.endDate,
  //     title: form.title,
  //     description: form.description,
  //     type: form.typesMenu,
  //     assignedType: form.assignedType,
  //     rewardForPatient: form.rewardForPatient,
  //     rewardForDoctor: form.rewardForDoctor,
  //     rewardCountGreaterThan: form.countStart,
  //     rewardCountLessThan: form.countEnd,
  //     rewardType: form.rewardType,
  //     rewardApply: form.rewardApply,
  //     assignTo: form.assignTo,
  //     status: form.publishStatus,
  //     assignedID: selectedIds,
  //   };

  //   const formData = new FormData();
  //   for (const key in payload) {
  //     if (key === "assignedID" && Array.isArray(payload.assignedID)) {
  //       payload.assignedID.forEach((id) => formData.append("assignedID[]", id));
  //     } else {
  //       formData.append(key, payload[key] ?? "");
  //     }
  //   }

  //   // FIX: Handle image properly - preserve existing image if no new upload
  //   if (imageFile instanceof File) {
  //     // New image uploaded
  //     formData.append("image", imageFile);
  //   } else if (initialData && hasExistingImage && initialData.image) {
  //     // No new image, but existing image should be preserved
  //     formData.append("image", initialData.image); // Send existing image path
  //   }
  //   // If no imageFile and no existing image, don't append anything (will use default)

  //   try {
  //     if (initialData) {
  //       await onUpdateOffer(formData);
  //       onShowMessageModal(true);
  //     } else {
  //       await dispatch(createOffer(formData));
  //       onOfferAdded && onOfferAdded(payload);
  //       onShowMessageModal(true);
  //     }
  //     onCloseModal();
  //     setSelectedIds([]);
  //   } catch (error) {
  //     console.error("Error submitting offer:", error);
  //   }
  // };
const handleSubmit = async (e) => {
  e.preventDefault();

  // Freshers ke liye Tip: Backend hamesha case-sensitive hota hai.
  // Humne 'rewardapply' (small 'a') use kiya hai.
  const isGlobal = form.typesMenu === "global";
  const finalAssignedType = isGlobal && !form.assignedType ? "all" : form.assignedType;

  const payload = {
    id: initialData?.id || null,
    hospitalID: 0, // Admin side se 0 jayega
    startDate: form.startDate,
    endDate: form.endDate,
    title: form.title,
    description: form.description,
    type: form.typesMenu,           // 'global' ya 'local'
    assignedType: finalAssignedType, // 'patient', 'doctor', ya 'all'
    rewardForPatient: form.rewardForPatient || "",
    rewardForDoctor: form.rewardForDoctor || "",
    rewardCountGreaterThan: form.countStart || "",
    rewardCountLessThan: form.countEnd || "",
    rewardType: form.rewardType || "",
    rewardapply: form.rewardapply || "", // Spelling Fix: Small 'a'
    assignTo: form.assignTo || "all",
    status: form.publishStatus || "Unpublish",
    // Agar Global hai toh assignedID khali array jayega
    assignedID: isGlobal ? [] : selectedIds, 
  };

  const formData = new FormData();
  
  // Payload ko FormData mein convert karna
  for (const key in payload) {
    if (key === "assignedID") {
      // Local offers ke liye saari selected IDs append karein
      if (Array.isArray(payload.assignedID) && payload.assignedID.length > 0) {
        payload.assignedID.forEach((id) => formData.append("assignedID[]", id));
      }
    } else {
      formData.append(key, payload[key] ?? "");
    }
  }

  // Image Handling Logic
  if (imageFile instanceof File) {
    // Agar user ne naya photo select kiya hai
    formData.append("image", imageFile);
  } else if (initialData?.image) {
    // Agar user Edit kar raha hai aur photo wahi purani rehne deni hai
    formData.append("image", initialData.image); 
  }

  try {
    if (initialData) {
      // Edit Operation
      await onUpdateOffer(formData);
      onShowMessageModal(true);
    } else {
      // Create Operation
      await dispatch(createOffer(formData));
      onOfferAdded && onOfferAdded(payload);
      onShowMessageModal(true);
    }
    onCloseModal();
    setSelectedIds([]);
  } catch (error) {
    console.error("Submission Error:", error);
    alert("Failed to save offer. Check console for details.");
  }
};
  const handleCancel = () => {
    onCloseModal();
    // Reset form but don't show success modal
    setForm({
      startDate: getTodayDateString(),
      endDate: getTodayDateString(),
      title: "",
      description: "",
      typesMenu: "",
      assignedType: "",
      rewardForPatient: "",
      rewardForDoctor: "",
      countStart: "",
      countEnd: "",
      rewardType: "",
      assignTo: "",
      publishStatus: "",
      rewardApply: "",
    });
    setPreview("/assets/img/offers/default_offer_image.jpg"); // Reset to default image
    setImageFile(null); // Clear image file
    setSelectedIds([]);
    setHasExistingImage(false);
  };

  const showPatientReward = form.assignedType === "patient";
  const showDoctorReward = form.assignedType === "doctor";

  function getRewardCell(item) {
    let doctorReward = "";
    if (item._type === "Doctor") {
      const stats = doctorArticleStats[item.hospitalID]; // Get doctor's calculated stats

      if (form.rewardForDoctor === "revenueAppointments") {
        doctorReward = `₹${
          doctorStats[item.hospitalID]?.revenue?.toFixed(2) || "0.00"
        }`;
      } else if (form.rewardForDoctor === "numAppointments") {
        doctorReward = `${doctorStats[item.hospitalID]?.count || 0}`;
      } else if (form.rewardForDoctor === "numArticles") {
        doctorReward = `${stats?.numArticles || 0}`; // Use stats.numArticles
      } else if (form.rewardForDoctor === "highestViewsArticles") {
        doctorReward = `${stats?.highestViews || 0}`; // Access the new highestViews property
      } else if (form.rewardForDoctor === "averageViewsArticles") {
        doctorReward = `${stats?.averageViews || "0.00"}`; // Access the new averageViews property
      }
    }

    let patientReward = "";
    if (item._type === "Patient") {
      if (form.rewardForPatient === "onRevenueAppointments") {
        patientReward = `₹${
          patientStats[item.PatientID]?.revenue?.toFixed(2) || "0.00"
        }`;
      } else if (form.rewardForPatient === "onCountAppointments") {
        patientReward = `${patientStats[item.PatientID]?.count || 0}`;
      } else if (form.rewardForPatient === "onFamilyCount") {
        patientReward = `${familyMemberCountByPatient[item.PatientID] || 0}`;
      }
    }

    return doctorReward || patientReward || "N/A";
  }
  return (
    <>
      <style>{createOfferCss}</style>
      <form className="special-offer-modal-mainform" onSubmit={handleSubmit}>
        {/* Left */}
        <div className="offer-form-pane px-2">
          <div className="offer-img-center">
            <div className="display-img-area ">
              <img
                className="offer-image"
                src={preview || "/assets/img/offers/default_offer_image.jpg"}
                alt="offer_image"
              />
            </div>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              style={{ marginBottom: 6 }}
            />
          </div>
          <div className="section-row">
            <div>
              <label className="label">Start date</label>
              <input
                type="date"
                className="form-control"
                value={form.startDate}
                onChange={handleChange("startDate")}
              />
            </div>
            <div>
              <label className="label">End date</label>
              <input
                type="date"
                className="form-control"
                value={form.endDate}
                onChange={handleChange("endDate")}
              />
            </div>
          </div>
          <div className="section-row">
            <div>
              <label className="label">Title</label>
              <input
                type="text"
                className="form-control"
                value={form.title}
                onChange={handleChange("title")}
              />
            </div>
          </div>
          <div className="section-row">
            <div>
              <label className="label">Description</label>
              <textarea
                className="form-control"
                value={form.description}
                onChange={handleChange("description")}
              />
            </div>
          </div>
          <div className="section-row">
            <div>
              <label className="label">Type/Menu</label>
              <select
                className="form-select"
                value={form.typesMenu}
                onChange={handleChange("typesMenu")}
              >
                {typesMenuOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">Assignee Type</label>
              <select
                className="form-select"
                value={form.assignedType}
                onChange={handleChange("assignedType")}
              >
                {AssignedTypeOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="section-row">
            {showPatientReward && (
              <div>
                <label className="label">Reward For Patient</label>
                <select
                  className="form-select"
                  value={form.rewardForPatient}
                  onChange={handleChange("rewardForPatient")}
                >
                  {rewardForPatientOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
            {showDoctorReward && (
              <div>
                <label className="label">Reward For Doctor</label>
                <select
                  className="form-select"
                  value={form.rewardForDoctor}
                  onChange={handleChange("rewardForDoctor")}
                >
                  {rewardForDoctorOptions.map((opt) => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            )}
            <div>
              <label className="label">Count Range</label>
              <div className="d-flex gap-2">
                <input
                  type="number"
                  className="form-control"
                  placeholder="start"
                  value={form.countStart}
                  onChange={handleChange("countStart")}
                  min={0}
                />
                <input
                  type="number"
                  className="form-control"
                  placeholder="end"
                  value={form.countEnd}
                  onChange={handleChange("countEnd")}
                  min={0}
                />
              </div>
            </div>
          </div>
          <div className="section-row">
            <div>
  <label className="label">Reward Type</label>
  <select
    className="form-select"
    value={form.rewardType}
    onChange={handleChange("rewardType")} // 'rewardType' state se match karein
  >
    {filteredRewardTypeOptions.map((opt) => (
      <option key={opt.value} value={opt.value}>
        {opt.label}
      </option>
    ))}
  </select>
</div>

           <div>
  <label className="label">Apply Reward</label>
  <input
    type="text"
    className="form-control"
    value={form.rewardapply || ""} // DHAYAN DEIN: small 'a'
    onChange={handleChange("rewardapply")} // small 'a'
    placeholder="e.g. 10"
  />
</div>
          </div>
          <div className="section-row">
            <div>
              <label className="label">Assign To</label>
              <select
                className="form-select"
                value={form.assignTo}
                onChange={handleChange("assignTo")}
              >
                {assignToOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="label">Publish Status</label>
              <select
                className="form-select"
                value={form.publishStatus}
                onChange={handleChange("publishStatus")}
              >
                {publishStatusOptions.map((opt) => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </div>

        <div className="offer-list-pane">
          <div className="chooser-header">
            <input
              type="checkbox"
              checked={selectAll}
              onChange={toggleSelectAll}
            />
            <span className="label">All</span>
            <input
              className="form-control chooser-search"
              placeholder="search"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
          </div>
          <label className="label" style={{ fontSize: 16 }}>
            Assigne List
          </label>
          <div className="chooser-list-outer">
            <div className="chooser-table-container">
              {form.typesMenu === "global" ? (
                <div>
                  <p>
                    This offer will automatically apply to{" "}
                    {form.assignedType === "all"
                      ? "All doctors and patients"
                      : form.assignedType === "doctor"
                      ? "All doctors"
                      : "All patients"}
                    . Manual selection is disabled.
                  </p>
                </div>
              ) : (
                <table className="chooser-table">
                  <thead>
                    <tr>
                      <th className="chooser-checkbox-cell"></th>
                      <th className ="label"style={{ minWidth: 150 }}>ID</th>
                      <th className ="label"style={{ minWidth: 150 }}>Name</th>
                      <th className ="label"style={{ minWidth: 180 }}>{rewardColumnHeader}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {displayedList.length === 0 ? (
                      <tr>
                        <td colSpan={4}>
                          <div className="no-list-data">No records found.</div>
                        </td>
                      </tr>
                    ) : (
                      displayedList.map((item) => {
                        const id = item.PatientID || item.hospitalID || item.id;
                        const label =
                          (item.firstName || "") + " " + (item.lastName || "");
                        return (
                          <tr key={id}>
                            <td>
                              <input
                                type="checkbox"
                                checked={selectedIds.includes(id)}
                                onChange={() => toggleSelect(id)}
                              />
                            </td>
                            <td>
                              {item._type === "Doctor"
                                ? `Doctor ID: ${
                                    item.hospitalID || item.id || ""
                                  }`
                                : `Patient ID: ${
                                    item.PatientID || item.id || ""
                                  }`}
                            </td>
                            <td>{label}</td>
                            <td>{getRewardCell(item)}</td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>

          <div className="button-bar-bottom ">
            <button
              type="button"
              className="btn btn-danger rounded-pill"
              onClick={handleCancel}
            >
              Cancel
            </button>
            <button className="btn btn-info rounded-pill" type="submit">
              {initialData ? "Update" : "Submit"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};
const offerForOptions = ["None", "Doctor", "Patient", "All"];
const statusOptions = ["None", "Publish", "Unpublish"];

// FIXED: Improved getOfferImage function to handle various image path formats
const getOfferImage = (offerImage) => {
  const defaultImagePath = "/assets/img/offers/default_offer_image.jpg";

  if (!offerImage || offerImage === "null" || offerImage === "undefined") {
    return defaultImagePath;
  }

  // If the image path is already a full URL or data URL, return it as is
  if (offerImage.startsWith("http") || offerImage.startsWith("data:")) {
    return offerImage;
  }

  // If the image path is already a relative path starting with /assets, return it as is
  if (offerImage.startsWith("/assets")) {
    return offerImage;
  }

  // Remove trailing slash from imgUrl if exists
  const baseUrl = imgUrl.endsWith("/") ? imgUrl.slice(0, -1) : imgUrl;

  // Remove leading slash from offerImage if exists
  const imagePath = offerImage.startsWith("/")
    ? offerImage.slice(1)
    : offerImage;

  return `${baseUrl}/${imagePath}`;
};

const AllOffers = (props) => {
  const {
    doctors,
    profiles,
    invoices,
    blogs,
    getAllDoctors,
    getAllPatientProfiles,
    listAllInvoices,
    listBlogs,
    fetchBlogMetrics,
    familyMembers,
    getFamilyMembers,
    metrics,
  } = props;
  const [statusUpdatingId, setStatusUpdatingId] = useState(null);
  const [viewOffer, setViewOffer] = useState(null);
  const [showViewModal, setShowViewModal] = useState(false);
  const [showEditOfferModal, setShowEditOfferModal] = useState(false);
  const [editingOffer, setEditingOffer] = useState(null);

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [offerFor, setOfferFor] = useState("None");
  const [status, setStatus] = useState("None");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [search, setSearch] = useState("");
  const [offers, setOffers] = useState([]);
  const [showAddOfferModal, setShowAddOfferModal] = useState(false);
  const [showMessageModal, setShowMessageModal] = useState(false);
  const [showConfirmDeleteModal, setShowConfirmDeleteModal] = useState(false);
  const [offerIdToDelete, setOfferIdToDelete] = useState(null);
  const [deleteResultMessage, setDeleteResultMessage] = useState({
    show: false,
    message: "",
    variant: "",
  });

  useEffect(() => {
    getAllDoctors();
    getAllPatientProfiles();
    listAllInvoices();
    getFamilyMembers();
    listBlogs();
    fetchBlogMetrics();
  }, [
    getAllDoctors,
    getAllPatientProfiles,
    listAllInvoices,
    getFamilyMembers,
    listBlogs,
    fetchBlogMetrics,
  ]); // Added dependencies

  const fetchOffers = async () => {
    try {
      const response = await dispatch(getOffer());
      if (response?.data) {
        // Ensure we have the latest image data from backend
        const mappedOffers = response.data.map((offer) => ({
          ...offer,
          assignedType: (offer.assignedType || "none").toLowerCase(),
          status: offer.status || "None",
          // Ensure image field is properly set from backend response
          image: offer.image || null,
        }));
        setOffers(mappedOffers);
      } else {
        setOffers([]);
      }
    } catch (error) {
      console.error("Failed to fetch offers", error);
      setOffers([]);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  // const handleTogglePublish = async (offer, index) => {
  //   setStatusUpdatingId(offer.id);

  //   const newStatus = offer.status === "Publish" ? "Unpublish" : "Publish";
  //   const updatedOffers = [...offers];
  //   updatedOffers[index] = { ...offer, status: newStatus };
  //   setOffers(updatedOffers);
  //   const formData = new FormData();
  //   formData.append("id", offer.id);
  //   formData.append("assignedType", offer.assignedType || "");
  //   formData.append("title", offer.title || "");
  //   formData.append("description", offer.description || ""); 
  //   formData.append("status", newStatus);
  //   formData.append("startDate", offer.startDate || "");
  //   formData.append("endDate", offer.endDate || "");
  //   formData.append("type", offer.type || "");
  //   formData.append("rewardForPatient", offer.rewardForPatient || "");
  //   formData.append("rewardForDoctor", offer.rewardForDoctor || "");
  //   formData.append(
  //     "rewardCountGreaterThan",
  //     offer.rewardCountGreaterThan || ""
  //   );
  //   formData.append("rewardCountLessThan", offer.rewardCountLessThan || "");
  //   formData.append("rewardType", offer.rewardType || "");
  //   formData.append("rewardApply", offer.rewardApply || "");
  //   formData.append("assignTo", offer.assignTo || "");
  //   if (offer.assignedID && Array.isArray(offer.assignedID)) {
  //     offer.assignedID.forEach((id) => formData.append("assignedID[]", id));
  //   }
   
  //   if (offer.image) {
  //     formData.append("existingImage", offer.image);
  //   }
  //   try {
  //     await dispatch(updateOffer(formData));
  //     await fetchOffers(); 
  //   } catch (error) {
  //     updatedOffers[index] = offer;
  //     setOffers(updatedOffers);
  //     console.error("Failed to update status:", error);
  //   } finally {
  //     setStatusUpdatingId(null);
  //   }
  // };

  const handleTogglePublish = async (offer, index) => {
  setStatusUpdatingId(offer.id); 

  const newStatus = offer.status === "Publish" ? "Unpublish" : "Publish";
  
  // Update local state for immediate UI feedback
  const updatedOffers = [...offers];
  updatedOffers[index] = { ...offer, status: newStatus };
  setOffers(updatedOffers);

  const formData = new FormData();
  formData.append("id", offer.id);
  formData.append("assignedType", offer.assignedType || "");
  formData.append("title", offer.title || "");
  formData.append("description", offer.description || ""); 
  formData.append("status", newStatus);
  formData.append("startDate", offer.startDate || "");
  formData.append("endDate", offer.endDate || "");
  formData.append("type", offer.type || "");
  formData.append("rewardForPatient", offer.rewardForPatient || "");
  formData.append("rewardForDoctor", offer.rewardForDoctor || "");
  formData.append("rewardCountGreaterThan", offer.rewardCountGreaterThan || "");
  formData.append("rewardCountLessThan", offer.rewardCountLessThan || "");
  formData.append("rewardType", offer.rewardType || "");
  formData.append("rewardApply", offer.rewardApply || "");
  formData.append("assignTo", offer.assignTo || "");
  
  if (offer.assignedID && Array.isArray(offer.assignedID)) {
    offer.assignedID.forEach((id) => formData.append("assignedID[]", id));
  }

  // CHANGE THIS: Match the key used in CreateOffersForm
  if (offer.image) {
    // Use "image" instead of "existingImage"
    formData.append("image", offer.image); 
  }

  try {
    await dispatch(updateOffer(formData));
    // Optional: Only fetch if your backend doesn't return the updated object
    await fetchOffers(); 
  } catch (error) {
    // Revert local state on error
    updatedOffers[index] = offer;
    setOffers(updatedOffers);
    console.error("Failed to update status:", error);
  } finally {
    setStatusUpdatingId(null);
  }
};
  const openEditModal = (offer) => {
    setEditingOffer(offer);
    setShowEditOfferModal(true);
  };

  const handleUpdateOffer = async (formData) => {
    try {
      await dispatch(updateOffer(formData));
      await fetchOffers(); 
    } catch (error) {
      console.error("Failed to update offer:", error);
      throw error; 
    }
  };

  const openViewModal = (offer) => {
    setViewOffer(offer);
    setShowViewModal(true);
  };

  const closeViewModal = () => {
    setShowViewModal(false);
    setViewOffer(null);
  };

  const confirmDelete = (id) => {
    setOfferIdToDelete(id);
    setShowConfirmDeleteModal(true);
  };

  const handleDeleteConfirmed = async () => {
    setShowConfirmDeleteModal(false);
    if (!offerIdToDelete) return;

    try {
      await dispatch(deleteOffer(offerIdToDelete));
      await fetchOffers(); // refresh the list
      setDeleteResultMessage({
        show: true,
        message: "Offer deleted successfully!",
        variant: "success",
      });
    } catch (error) {
      setDeleteResultMessage({
        show: true,
        message: "Failed to delete offer. Please try again.",
        variant: "danger",
      });
    } finally {
      setOfferIdToDelete(null);
    }
  };

  useEffect(() => {
    fetchOffers();
  }, []);

  if (loading) {
    return (
      <div className="text-center my-5">
        <Spinner animation="border" />
      </div>
    );
  }

  const handleOfferAdded = (newOfferData) => {
    fetchOffers();
    setShowAddOfferModal(false); // Close the add offer modal
    // Don't set showMessageModal here - it will be handled in the form
  };

  const normalizedOfferFor = offerFor.toLowerCase();

  const filteredOffers = [...offers]
    .sort((a, b) => b.id - a.id)
    .filter((offer) => {
      // Filter by assignedType (offerFor)
      if (offerFor === "none") {
        // Show all offers
      } else if (offerFor === "all") {
        // Only show offers with assignedType equal to 'all'
        if (!offer.assignedType || offer.assignedType.toLowerCase() !== "all") {
          return false;
        }
      } else if (offerFor === "doctor" || offerFor === "patient") {
        if (
          !offer.assignedType ||
          offer.assignedType.toLowerCase() !== offerFor
        ) {
          return false;
        }
      }

      // Filter by status
      if (status !== "None" && offer.status !== status) {
        return false;
      }

      // Filter by search text in title or description (case-insensitive)
      if (search.trim()) {
        const lowerSearch = search.trim().toLowerCase();
        if (
          !offer.title?.toLowerCase().includes(lowerSearch) &&
          !offer.description?.toLowerCase().includes(lowerSearch)
        ) {
          return false;
        }
      }

      // Filter by start date range
      if (startDate && new Date(offer.startDate) < new Date(startDate)) {
        return false;
      }

      // Filter by end date range
      if (endDate && new Date(offer.endDate) > new Date(endDate)) {
        return false;
      }

      return true;
    });

  const formatShortText = (text, maxLength) => {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substr(0, maxLength) + "...";
  };
  const formatAssignedType = (type) => {
    switch (type.toLowerCase()) {
      case "doctor":
        return "Doctor";
      case "patient":
        return "Patient";
      case "all":
        return "All";
      default:
        return "-";
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (isNaN(date)) return "";
    return date.toLocaleDateString(); // You can customize format as needed
  };

  return (
    <>
      <div className="page-wrapper ml-0">
            <div className="content-container">

         <div className="page-header filter-bar rounded">
                          <div className="row align-items-center">
                            <div className="col">
                              <h4 className="page-title">All Offers</h4>
                              <ul className="breadcrumb">
                                <li className="breadcrumb-item">
                                  <Link to="/doctor/dashboard">Admin Dashboard</Link>
                                </li>
                                <li className="breadcrumb-item active">Offers</li>
                              </ul>
                            </div>
                          </div>
                        </div>
                

        {/* Filters */}
        <div className="d-flex gap-2 flex-wrap mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Search Title or Content"
            style={{ maxWidth: 300 }}
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />

          <select
            id="offerFor"
            className="form-select"
            style={{ maxWidth: 150 }}
            value={offerFor}
            onChange={(e) => setOfferFor(e.target.value)}
          >
            {["None", "Doctor", "Patient", "All"].map((opt) => (
              <option key={opt} value={opt.toLowerCase()}>
                {opt}
              </option>
            ))}
          </select>

          <select
            id="status"
            className="form-select"
            style={{ maxWidth: 150 }}
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            {["None", "Publish", "Unpublish"].map((opt) => (
              <option key={opt} value={opt}>
                {opt}
              </option>
            ))}
          </select>

          <input
            type="date"
            id="startDate"
            className="form-control"
            style={{ maxWidth: 150 }}
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />

          <input
            type="date"
            id="endDate"
            className="form-control"
            style={{ maxWidth: 150 }}
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />

          <button
            className="btn btn-info rounded-pill my-1"
            onClick={() => setShowAddOfferModal(true)}
          >
            Add Offer
          </button>
        </div>

        {loading ? (
          <div className="text-center my-5">
            <div className="spinner-border"></div>
          </div>
        ) : filteredOffers.length === 0 ? ( // Use filteredOffers here
          <div className="text-center my-5 text-muted">
            <i className="fas fa-tags fa-3x mb-3"></i>
            <p>No offers found matching your criteria.</p>
          </div>
        ) : (
          <div className="card">
          <div className="card-body">
          <Table hover responsive className="align-middle">
            <thead>
              <tr>
                <th>Offer ID</th>
                <th>Image</th>
                <th>Title</th>
                <th>Offer For</th>
                <th>Status</th>
                <th>Start Date</th>
                <th>End Date</th>
                <th>Publish</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredOffers.map(
                (
                  offer,
                  index // Iterate over filteredOffers
                ) => (
                  <tr key={offer.id}>
                    <td>{offer.id}</td>
                    <td>
                      <img
                        src={getOfferImage(offer.image)}
                        alt="Offer"
                        style={{
                          width: 40,
                          height: 40,
                          borderRadius: "50%", // Circular like doctor images on Blogs
                          objectFit: "cover",
                          marginRight: 10,
                        }}
                        onError={(e) => {
                          // If image fails to load, show default image
                          e.target.src =
                            "/assets/img/offers/default_offer_image.jpg";
                        }}
                      />
                    </td>
                    <td>{formatShortText(offer.title, 30)}</td>
                    <td>{formatAssignedType(offer.assignedType)}</td>

                    <td>
                      <span
                        className={
                          offer.status === "Publish"
                            ? "publish-label"
                            : "unpublish-label"
                        }
                      >
                        {offer.status === "Publish" ? "Publish" : "Unpublish"}
                      </span>
                    </td>
                    <td>{formatDate(offer.startDate)}</td>
                    <td>{formatDate(offer.endDate)}</td>

                    <td>
                      <div>
                        <input
                          type="checkbox"
                          id={`toggle_${offer.id}`}
                          className="check"
                          checked={offer.status === "Publish"}
                          onChange={() => handleTogglePublish(offer, index)}
                          disabled={statusUpdatingId === offer.id}
                        />
                        <label
                          htmlFor={`toggle_${offer.id}`}
                          className="checktoggle"
                        ></label>
                      </div>
                    </td>
                    <td>
                      <button
                        size="sm"
                        className="i-btn-view"
                        onClick={() => openViewModal(offer)}
                      >
                      
                      </button>
                      <button
                        size="sm"
                        className="i-btn-edit"
                        onClick={() => openEditModal(offer)}
                      >
                     
                      </button>
                      <button
                        size="sm"
                        className="i-btn-delete"
                        onClick={() => confirmDelete(offer.id)}
                      >
                      
                      </button>
                    </td>
                  </tr>
                )
              )}
            </tbody>
          </Table>
          </div>
          </div>
        )}
        <CModal
          show={showEditOfferModal}
          onClose={() => {
            setShowEditOfferModal(false);
            setEditingOffer(null);
          }}
          centered
          size="xl"
        >
          <Modal
            show={showConfirmDeleteModal}
            onHide={() => setShowConfirmDeleteModal(false)}
            centered
          >
            <Modal.Header className='bg-danger text-white ' closeButton closeVariant="white">
              <Modal.Title>Confirm Delete</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              Are you sure you want to delete this offer? This action cannot be
              undone.
            </Modal.Body>
            <Modal.Footer>
              {/* <button
                className="cancel-button"
                onClick={() => setShowConfirmDeleteModal(false)}
              >
                Cancel
              </button> */}
              <button className="btn btn-danger rounded-pill my-1 " onClick={handleDeleteConfirmed}>
                Delete
              </button>
            </Modal.Footer>
          </Modal>

          <CModalHeader className='bg-info text-white ' closeButton closeVariant="white">Edit Offer</CModalHeader>
          <CModalBody>
            <CreateOffersForm
              initialData={editingOffer}
              onCloseModal={() => {
                setShowEditOfferModal(false);
                setEditingOffer(null);
              }}
              onUpdateOffer={handleUpdateOffer}
              onShowMessageModal={setShowMessageModal}
              doctors={doctors}
              profiles={profiles}
              invoices={invoices}
              blogs={blogs}
              familyMembers={familyMembers}
              metrics={metrics}
            />
          </CModalBody>
        </CModal>

        <Modal show={showViewModal} onHide={closeViewModal} centered size="lg">
          <Modal.Header className='bg-info text-white ' closeButton>
            <Modal.Title >Offer Details</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {viewOffer ? (
              <>
                <p>
                  <strong>Offer ID:</strong> {viewOffer.id}
                </p>
                <p>
                  <strong>Title:</strong> {viewOffer.title}
                </p>
                <p>
                  <strong>Type:</strong> {viewOffer.type}
                </p>
                <p>
                  <strong>Offer For:</strong> {viewOffer.assignedType}
                </p>
                <p>
                  <strong>Status:</strong> {viewOffer.status}
                </p>
                <p>
                  <strong>Start Date:</strong>{" "}
                  {new Date(viewOffer.startDate).toLocaleDateString()}
                </p>
                <p>
                  <strong>End Date:</strong>{" "}
                  {new Date(viewOffer.endDate).toLocaleDateString()}
                </p>

                <img
                  src={getOfferImage(viewOffer.image)}
                  alt="Offer"
                  style={{
                    width: "100%",
                    maxHeight: 200,
                    objectFit: "cover",
                    marginBottom: 10,
                  }}
                  onError={(e) => {
                    e.target.src = "/assets/img/offers/default_offer_image.jpg";
                  }}
                />
                <p>
                  <strong>Description:</strong>{" "}
                  {viewOffer.description || "No description."}
                </p>
              </>
            ) : null}
          </Modal.Body>
        </Modal>

        <CModal
          show={showAddOfferModal}
          onClose={() => setShowAddOfferModal(false)}
          centered
          size="xl"
        >
          
          <CModalHeader className='bg-info text-white 'closeButton closeVariant="white">Add New Offer</CModalHeader>
          <CModalBody>
 
  {showAddOfferModal && (
    <CreateOffersForm
      onCloseModal={() => setShowAddOfferModal(false)}
      onOfferAdded={handleOfferAdded}
      onShowMessageModal={setShowMessageModal}
      doctors={doctors}
      profiles={profiles}
      invoices={invoices}
      blogs={blogs}
      familyMembers={familyMembers}
      metrics={metrics}
    />
  )}
</CModalBody>
        </CModal>
        {/* Success Modal */}
        <MessageModal
          show={showMessageModal}
          onClose={() => setShowMessageModal(false)}
          title="Success!"
          message="Offer Submitted Successfully"
          variant="success"
        />
      
      </div>
    </div>
    </>
  );
};
const mapStateToProps = (state) => ({
  doctors: state.doctorList?.doctors || [],
  profiles: state.patientProfile?.profiles || [],
  invoices: state.invoice?.invoices || [],
  blogs: state.blogReducer.blogs || [],
  familyMembers: state.familyMembers?.members?.data || [],
  metrics: state.blogMetricsReducer.metrics || {},
});
export default connect(mapStateToProps, {
  getAllDoctors,
  getAllPatientProfiles,
  listAllInvoices,
  listBlogs,
  getFamilyMembers,
  fetchBlogMetrics,
})(AllOffers);
